  <template>
  <div>
    <div id="container"></div>
    <!-- 创建弹窗 -->
    <el-dialog
      :title="groupTitle"
      :visible.sync="addDailog"
      width="61.8%"
      :custom-class="`addlist ${customClass}`"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      @closed="closenew()"
    >
      <div id="group">
        <div v-if="createtype=='user'" class="user">
          <div class="adduserTop">
            <ul class="clearfix" v-if="!unionStatus">
              <li
                :class="['fl',{'active':item.id==tabactiveid}]"
                v-for="item in squaretab"
                @click="changetab(item.id)"
              >{{item.name}}</li>
            </ul>
            <div class="addusersearch">
              <input
                type="text"
                v-model="searchText"
                @keyup.enter="searchfriends"
                :placeholder="unionStatus?'请输入搜索内容':'请输入手机号/UMID/昵称'"
              />
              <button @click="searchfriends">搜索</button>
            </div>
          </div>
          <div
            class="searchuserlists"
            :style="{'height':height2-60-squaresearch+'px'}"
            v-show="tabactiveid==0&&!searchBoxshow&&!unionStatus"
          >
            <div
              v-for="(item,index) in squarelist"
              class="adduserBottom"
              v-if="squarelist[index].list.length>0"
            >
              <div class="listtitle vCenter">
                <span>{{item.name}}</span>
                <span
                  v-if="squarelist[index].shownum<=8&&item.list.length>8"
                  class="refresh"
                  @click="squarelistmore(item.id)"
                >更多</span>
                <span
                  v-if="squarelist[index].shownum>8&&item.list.length>8"
                  class="refresh"
                  @click="squarelistmore(item.id)"
                >收起</span>
              </div>
              <ul>
                <el-row :gutter="10">
                  <el-col
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="8"
                    :xl="8"
                    v-for="(m,index) in item.list.slice(0,item.shownum)"
                    :key="index"
                  >
                    <li class="clearfix">
                      <div class="fl">
                        <img
                          :src="m.avatar"
                          alt
                          class="fr avatar"
                          v-if="m.avatar"
                        />
                        <div
                          v-if="!m.avatar"
                          class="defaultAvatar fr avatar"
                        >{{avaname(m.sumname)}}</div>
                      </div>
                      <div class="fl">
                        <div class="info">
                          <div class="clearfix">
                            <div class="sumname fl">{{m.sumname}}</div>
                            <div class="job fl">{{m.job}}</div>
                          </div>
                          <div class="sphone" v-if="!m.isfriend">{{hidenum(m.sphone)}}</div>
                          <div class="sphone" v-if="m.isfriend">{{m.sphone}}</div>
                          <div class="company">{{m.company}}</div>
                        </div>
                        <div class="buttongroup">
                          <button v-if="!m.isfriend" @click="openchat(m,1,m)">打招呼</button>
                          <button v-if="m.isfriend" @click="openchat(m,1,m)">发消息</button>
                          <button
                            v-if="!m.isfriend"
                            @click="addfriend(m.umid,m,m)"
                          >加好友</button>
                          <button v-if="m.isfriend">好友</button>
                        </div>
                      </div>
                    </li>
                  </el-col>
                </el-row>
              </ul>
              <div style="text-align:center" v-show="item.shownum<=20&&item.shownum>8">
                <el-pagination
                  v-show="item.total>1"
                  layout="prev, pager, next"
                  @current-change="sizeChange($event,item.id)"
                  @click="aaaa"
                  :page-count="item.total"
                ></el-pagination>
              </div>
            </div>
          </div>
          <div
            class="searchuserlists"
            :style="{'height':height2-60-squaresearch+'px'}"
            v-show="tabactiveid==1&&!searchBoxshow&&!unionStatus"
          >
            <div
              v-for="(item,index) in squarelist1"
              class="adduserBottom"
              v-if="squarelist1[index].list.length>0"
            >
              <div class="listtitle vCenter">
                <span>{{item.name}}</span>
                <span
                  v-if="squarelist1[index].shownum<=8&&item.list.length>8"
                  class="refresh"
                  @click="squarelistmore1(item.id)"
                >更多</span>
                <span
                  v-if="squarelist1[index].shownum>8&&item.list.length>8"
                  class="refresh"
                  @click="squarelistmore1(item.id)"
                >收起</span>
              </div>
              <ul>
                <el-row :gutter="10">
                  <el-col
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="8"
                    :xl="8"
                    v-for="(m,index) in item.list.slice(0,item.shownum)"
                    :key="index"
                  >
                    <li class="clearfix">
                      <div class="fl">
                        <img :src="m.companylogo" alt class="fr avatar" v-if="m.companylogo" />
                      </div>
                      <div class="fl">
                        <div class="info">
                          <div class="clearfix">
                            <div class="sumname fl" style="max-width:100%">{{m.orgname}}</div>
                          </div>
                          <div class="company">{{m.companydesc}}</div>
                        </div>
                        <div class="buttongroup">
                          <button v-if="!m.inroom" @click="openchat(m,1,m.umidinfo)">联系管理</button>
                          <button v-if="!m.inroom" @click="applyorg(m.orgid)">申请加入</button>
                          <button v-if="m.inroom">已加入</button>
                        </div>
                      </div>
                    </li>
                  </el-col>
                </el-row>
              </ul>
              <div style="text-align:center" v-show="item.shownum<=20&&item.shownum>8">
                <el-pagination
                  v-show="item.total>1"
                  layout="prev, pager, next"
                  @current-change="sizeChange1($event,item.id)"
                  @click="aaaa"
                  :page-count="item.total"
                ></el-pagination>
              </div>
            </div>
          </div>
          <div
            class="searchuserlists"
            :style="{'height':height2-60-squaresearch+'px'}"
            v-show="tabactiveid==2&&!searchBoxshow&&!unionStatus"
          >
            <div
              v-for="(item,index) in squarelist2"
              class="adduserBottom"
              v-if="squarelist2[index].list.length>0"
            >
              <div class="listtitle vCenter">
                <span>{{item.name}}</span>
                <span
                  v-if="squarelist2[index].shownum<=8&&item.list.length>8"
                  class="refresh"
                  @click="squarelistmore2(item.id)"
                >更多</span>
                <span
                  v-if="squarelist2[index].shownum>8&&item.list.length>8"
                  class="refresh"
                  @click="squarelistmore2(item.id)"
                >收起</span>
              </div>
              <ul>
                <el-row :gutter="10">
                  <el-col
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="8"
                    :xl="8"
                    v-for="(m,index) in item.list.slice(0,item.shownum)"
                    :key="index"
                  >
                    <li class="clearfix">
                      <div class="fl">
                        <img :src="m.logopath" alt class="fr avatar" v-if="m.logopath" />
                      </div>
                      <div class="fl">
                        <div class="info">
                          <div class="clearfix">
                            <div class="sumname fl" style="max-width:100%">{{m.roomname}}</div>
                          </div>
                          <div class="company">{{m.roomremark}}</div>
                        </div>
                        <div class="buttongroup">
                          <button v-if="!m.inroom" @click="openchat(m,1,m.umidinfo)">联系群主</button>
                          <button v-if="m.inroom" @click="openchatroom(m)">发消息</button>
                          <button v-if="!m.inroom" @click="applygroup(m.roomid)">申请加入</button>
                          <button v-if="m.inroom">已加入</button>
                        </div>
                      </div>
                    </li>
                  </el-col>
                </el-row>
              </ul>
              <div style="text-align:center" v-show="item.shownum<=20&&item.shownum>8">
                <el-pagination
                  v-show="item.total>1"
                  layout="prev, pager, next"
                  @current-change="sizeChange2($event,item.id)"
                  @click="aaaa"
                  :page-count="item.total"
                ></el-pagination>
              </div>
            </div>
          </div>
          <div
            class="searchuserlists defaultPart center vCenter"
            v-show="unionStatus&&!searchBoxshow"
          >
            <div>
              <img src="/img/setting/default.png" alt />
              <div>请输入组织名称进行搜索 ...</div>
            </div>
          </div>
          <div
            class="searchuserlists"
            :style="{'height':height2-60-squaresearch+'px'}"
            v-if="searchBoxshow"
          >
            <div class="adduserBottom" v-if="tabactiveid==0&&!unionStatus">
              <div class="listtitle">找到{{searchuserlist.length}}人</div>
              <ul>
                <el-row :gutter="10">
                  <el-col
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="8"
                    :xl="8"
                    v-for="(m,index) in searchuserlist"
                    :key="index"
                  >
                    <li class="clearfix">
                      <div class="fl">
                        <img
                          :src="m.avatar"
                          alt
                          class="fr avatar"
                          v-if="m.avatar"
                        />
                        <div
                          v-if="!m.avatar"
                          class="defaultAvatar fr avatar"
                        >{{avaname(m.sumname)}}</div>
                      </div>
                      <div class="fl">
                        <div class="info">
                          <div class="clearfix">
                            <div class="sumname fl">{{m.sumname}}</div>
                            <div class="job fl">{{m.job}}</div>
                          </div>
                          <div class="sphone" v-if="!m.isfriend">{{hidenum(m.sphone)}}</div>
                          <div class="sphone" v-if="m.isfriend">{{m.sphone}}</div>
                          <div class="company">{{m.company}}</div>
                        </div>
                        <div class="buttongroup">
                          <button v-if="!m.isfriend" @click="openchat(m,1,m)">打招呼</button>
                          <button v-if="m.isfriend" @click="openchat(m,1,m)">发消息</button>
                          <button
                            v-if="!m.isfriend"
                            @click="addfriend(m.umid,m,m)"
                          >加好友</button>
                          <button v-if="m.isfriend">好友</button>
                        </div>
                      </div>
                    </li>
                  </el-col>
                </el-row>
              </ul>
            </div>
            <div class="adduserBottom" v-if="tabactiveid==1&&!unionStatus">
              <div class="listtitle">找到{{searchuserlist.length}}个组织</div>
              <ul>
                <el-row :gutter="10">
                  <el-col
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="8"
                    :xl="8"
                    v-for="(m,index) in searchuserlist"
                    :key="index"
                  >
                    <li class="clearfix">
                      <div class="fl">
                        <img :src="m.companylogo" alt class="fr avatar" v-if="m.companylogo" />
                      </div>
                      <div class="fl">
                        <div class="info">
                          <div class="clearfix">
                            <div class="sumname fl" style="max-width:100%">{{m.orgname}}</div>
                          </div>
                          <div class="company">{{m.companydesc}}</div>
                        </div>
                        <div class="buttongroup">
                          <button v-if="!m.inorg" @click="openchat(m,1,m.umidinfo)">联系管理</button>
                          <button v-if="!m.inorg" @click="applyorg(m.orgid)">申请加入</button>
                          <button v-if="m.inorg">已加入</button>
                        </div>
                      </div>
                    </li>
                  </el-col>
                </el-row>
              </ul>
            </div>
            <div class="adduserBottom" v-if="tabactiveid==2&&!unionStatus">
              <div class="listtitle">找到{{searchuserlist.length}}个群</div>
              <ul>
                <el-row :gutter="10">
                  <el-col
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="8"
                    :xl="8"
                    v-for="(m,index) in searchuserlist"
                    :key="index"
                  >
                    <li class="clearfix">
                      <div class="fl">
                        <img :src="m.logopath" alt class="fr avatar" v-if="m.logopath" />
                      </div>
                      <div class="fl">
                        <div class="info">
                          <div class="clearfix">
                            <div class="sumname fl" style="max-width:100%">{{m.roomname}}</div>
                            <!-- <div class="job fl">{{m.roomremark}}</div> -->
                          </div>
                          <div class="company">{{m.roomremark}}</div>
                        </div>
                        <div class="buttongroup">
                          <button v-if="!m.inroom" @click="openchat(m,1,m.umidinfo)">联系群主</button>
                          <button v-if="m.inroom" @click="openchatroom(m)">发消息</button>
                          <button v-if="!m.inroom" @click="applygroup(m.roomid)">申请加入</button>
                          <button v-if="m.inroom">已加入</button>
                        </div>
                      </div>
                    </li>
                  </el-col>
                </el-row>
              </ul>
            </div>
            <div class="adduserBottom" v-if="unionStatus">
              <div
                class="listtitle"
              >找到{{searchuserlist.length}}个组织（当前身份为组织身份，申请加入为申请成为该组织下级，邀请加入为邀请成为该组织上级）</div>
              <ul>
                <el-row :gutter="10">
                  <el-col
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="8"
                    :xl="8"
                    v-for="(m,index) in searchuserlist"
                    :key="index"
                  >
                    <li class="clearfix" @mouseleave="rightListhide">
                      <img class="icon" v-if="m.tag==1" src="/img/superior.png" alt />
                      <img class="icon" v-if="m.tag==2" src="/img/subordinate.png" alt />
                      <div class="fl">
                        <img :src="m.companylogo" alt class="fr avatar" v-if="m.companylogo" />
                      </div>
                      <div class="fl" style="flex: 1;width: 0;margin-right: 10px;">
                        <div class="info">
                          <div class="clearfix">
                            <div class="sumname fl" style="max-width:100%">{{m.orgname}}</div>
                          </div>
                          <div class="company">{{m.companydesc}}</div>
                        </div>
                      </div>
                      <i
                        class="iconfont fr"
                        style="width:20px;cursor: pointer"
                        v-if="m.tag==0"
                        @mouseenter="rightList(index,$event)"
                      >&#xe660;</i>
                      <ul id="rightList" v-show="showRightList==index">
                        <li v-if="m.tag==0" @click="openchat(m,1,m.umidinfo)">联系管理员</li>
                        <li v-if="m.tag==0" @click="applyorg(m.orgid,1)">申请加入</li>
                        <li v-if="m.tag==0" @click="applyorg(m.orgid,2)">邀请加入</li>
                        <li v-if="m.tag==1||m.tag==2">已加入</li>
                        <!-- <li @click.stop="gxorgid=item.orgid;gxshow=true">组织关系</li> -->
                      </ul>
                    </li>
                  </el-col>
                </el-row>
              </ul>
            </div>
          </div>
          <um-dialog :show.sync="showid" @showchange="showchangeFun">
            <template slot-scope="props">
              <div class="popup-content">
                <div
                  v-if="!isfriend&&dialogInfo.umid!=mine&&!apply_group&&!apply_org"
                  class="sendMsg"
                >
                  <div>请输入验证消息</div>
                  <el-input
                    type="textarea"
                    placeholder="我是..."
                    v-model="validationMsg"
                    resize="none"
                    @focus="setvalue"
                  ></el-input>
                  <div>为朋友设置备注</div>
                  <el-input v-model="desname" placeholder="为朋友设置备注" class="desname"></el-input>
                </div>
                <div v-else-if="isfriend&&dialogInfo.umid!=mine">你们已经是好友了，快去聊天吧！</div>
                <div v-else-if="dialogInfo.umid==mine">不能添加自己为好友，换个帐号试试吧！</div>
                <div v-else-if="!isfriend&&apply_group&&!apply_org">
                  <div>请输入验证消息</div>
                  <el-input
                    type="textarea"
                    placeholder="我是..."
                    v-model="validationGroupMsg"
                    resize="none"
                    @focus="setvalue"
                  ></el-input>
                </div>
                <div v-else-if="!isfriend&&!apply_group&&apply_org">
                  <div>请输入验证消息</div>
                  <el-input
                    type="textarea"
                    placeholder="我是..."
                    v-model="validationOrgMsg"
                    resize="none"
                    @focus="setvalue"
                  ></el-input>
                </div>
              </div>
              <div
                class="popup-footer"
                v-if="!isfriend&&dialogInfo.umid!=mine&&!apply_group&&!apply_org"
              >
                <button @click="sendApply(dialogInfo.umid)" class="confirm">发送</button>
                <button @click="showchangeFun()" class="cancel">取消</button>
              </div>
              <div class="popup-footer" v-if="!isfriend&&apply_group&&!apply_org">
                <button @click="sendApply(applyroomid)" class="confirm">发送</button>
                <button @click="showchangeFun()" class="cancel">取消</button>
              </div>
              <div class="popup-footer" v-if="!isfriend&&!apply_group&&apply_org">
                <button v-if="!unionStaus" @click="sendApply(applyorgid)" class="confirm">发送</button>
                <button v-if="unionStaus" @click="sendApply(applyorgid)" class="confirm">发送</button>
                <button @click="showchangeFun()" class="cancel">取消</button>
              </div>

              <div class="popup-footer" v-else-if="isfriend&&dialogInfo.umid!=mine">
                <button
                  @click="openchat(dialogInfo.item,1,dialogInfo.item)"
                  class="confirm"
                >发起聊天</button>
                <button @click="showchangeFun()" class="cancel">取消</button>
              </div>
              <div class="popup-footer" v-else-if="dialogInfo.umid==mine">
                <button @click="showchangeFun()">确定</button>
              </div>
            </template>
          </um-dialog>
        </div>
        <div v-if="createtype=='org'">
          <el-form ref="form" :rules="rules" :model="form" label-width="120px">
            <el-form-item label="组织LOGO上传" prop="logopath" required>
              <div class="vCenter">
                <img :src="form.logopath" alt class="logopath" @click="upload1" />
                <div style="margin-left:20px;flex:1">
                  <p>点击头像进行选择，点击上传按钮可上传本地图片。</p>
                  <ul class="clearfix chooselist">
                    <li class="fl">
                      <um-img
                        @submit-file="confirmgroup1($event,'org')"
                        :submitStatus="submitImgStatus"
                        v-on:getImgSrc="orgImg"
                        :uploadlogo="orgupload"
                      ></um-img>
                    </li>
                    <li v-for="item in defaultIcon" class="fl">
                      <img :src="item.path" alt @click="choosecolor(item,'o')" />
                      <img
                        src="/img/select.png"
                        alt
                        class="selectcolor"
                        v-show="item.id==selectcolor"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="组织名称" prop="orgname">
              <el-input v-model="form.orgname"></el-input>
            </el-form-item>
            <el-form-item label="组织简称" prop="orgshortname">
              <el-input v-model="form.orgshortname"></el-input>
            </el-form-item>
            <el-form-item label="组织类型" prop="type">
              <el-select :popper-append-to-body="false" v-model="form.value" placeholder="请选择组织类型">
                <el-option
                  v-for="item in form.options"
                  :key="item.orgtypeid"
                  :label="item.orgtypename"
                  :value="item.orgtypeid"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="固定电话" prop="orgtel">
              <el-input v-model="form.orgtel"></el-input>
            </el-form-item>
            <el-form-item label="官网地址" prop="orghomepage">
              <el-input v-model="form.homepage"></el-input>
            </el-form-item>
            <el-form-item label="组织邮箱" prop="orgemail">
              <el-input v-model="form.orgemail"></el-input>
            </el-form-item>
            <el-form-item label="组织简介" prop="orgdesc">
              <el-input type="textarea" v-model="form.orgdesc"></el-input>
            </el-form-item>
            <el-form-item label="所在地区">
              <div class="input-item">
                <select id="province" @change="search1($event.target)"></select>
              </div>
              <div class="input-item">
                <select id="city" @change="search1($event.target)"></select>
              </div>
              <div class="input-item">
                <select id="district" @change="search1($event.target)"></select>
              </div>
              <!-- <v-distpicker class="distpicker" @province="selectProvince" @city="selectCity" @area="selectArea" :province="address.province" :city="address.city" :area="address.area" @selected="onSelectedAddress"></v-distpicker> -->
            </el-form-item>
            <el-form-item label="开启组织权限">
              <el-switch
                v-model="form.jurisdiction"
                active-color="#409EFF"
                inactive-color="#6c6c6c">
              </el-switch>
              <div>启用权限后成员只能看到当前部门与下级部门数据</div>
            </el-form-item>
            <!-- <el-form-item label="主页背景">
              <um-simg
                @submit-file="confirmgroup2($event,'org1')"
                :submitStatus="submitImgStatus"
                class="cpbackground"
                v-on:getImgSrc="receiveImgSrc"
                :uploadlogo="form.companybackground"
              ></um-simg>
            </el-form-item> -->
          </el-form>
        </div>
        <div v-if="createtype=='homepage'" class="homepageedit">
          <el-form ref="hpform" :model="hpform" label-width="120px">
            <el-form-item label="已选项目">
              <div v-for="(item,index) in hpform.navlist" :key="index">
                <div class="vCenter">
                  <!-- <el-checkbox style="width: 140px;" :checked="item.checked" @change="curHpItemCheckedChange(index)">{{item.sname}}</el-checkbox> -->
                  <input
                    type="checkbox"
                    value
                    :checked="item.checked"
                    @click="curHpItemCheckedChange(index)"
                  />
                  <div style="width: 140px;">{{item.sname}}</div>
                  <el-button type="text" @click="editHpItem(item, index)">编辑</el-button>
                  <el-button type="text" @click="delHpItem(index)">删除</el-button>
                </div>
                <div class="newview" v-show="hpform.curindex == index">
                  <div class="vCenter">
                    <div class="hptitlelab">项目名称：</div>
                    <el-input placeholder="请输入项目名称" v-model="hpform.edititem.caption"></el-input>
                  </div>
                  <div class="vCenter">
                    <div class="hptitlelab">项目类型：</div>
                    <el-radio-group v-model="hpform.edititem.itype">
                      <el-radio label="0">网页url</el-radio>
                      <el-radio label="1">自定义页面</el-radio>
                      <el-radio label="2">独立网页</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="vCenter">
                    <div class="hptitlelab">项目地址：</div>
                    <el-input placeholder="请输入项目地址" v-model="hpform.edititem.url"></el-input>
                  </div>
                  <div class="vCenter">
                    <div class="hptitlelab">dappid：</div>
                    <el-input placeholder="请输入dappid(没有可不填)" v-model="hpform.edititem.dappid"></el-input>
                  </div>
                  <div class="vCenter">
                    <div class="hptitlelab">appid：</div>
                    <el-input placeholder="请输入appid(没有可不填)" v-model="hpform.edititem.appid"></el-input>
                  </div>
                  <div class="newsubmitdiv vCenter">
                    <el-button size="mini" @click="hpform.curindex = -1">取消</el-button>
                    <el-button size="mini" type="primary" @click="commitEditHpItem(index)">确定</el-button>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <el-form ref="hpform" :model="hpform" label-width="120px">
            <el-form-item label="可选项目">
              <div>
                <label v-for="item in hpform.dapplist" :key="item.indexname">
                  <input
                    name="Fruit"
                    type="checkbox"
                    value
                    :checked="item.checked"
                    :disabled="item.checked"
                    @click="selectHpItem(item)"
                  />
                  {{item.indexname}}
                </label>
                <!-- <el-checkbox-group v-model="hpform.sellist">
                                  <el-checkbox 
                                    v-for="item in hpform.dapplist" 
                                    :key="item.indexname"
                                    :label="item.indexname" 
                                    :disabled="item.checked">
                                  </el-checkbox>
                </el-checkbox-group>-->
              </div>
              <el-button type="text" @click="hpform.showNewView=true">添加自定义项</el-button>
              <div class="newview" v-show="hpform.showNewView">
                <div class="vCenter">
                  <div class="hptitlelab">项目名称：</div>
                  <el-input placeholder="请输入项目名称" v-model="hpform.newitem.caption"></el-input>
                </div>
                <div class="vCenter">
                  <div>项目类型：</div>
                  <el-radio-group v-model="hpform.newitem.itype">
                    <el-radio label="0">网页url</el-radio>
                    <el-radio label="1">自定义页面</el-radio>
                    <el-radio label="2">独立网页</el-radio>
                  </el-radio-group>
                </div>
                <div class="vCenter">
                  <div class="hptitlelab">项目地址：</div>
                  <el-input placeholder="请输入项目地址" v-model="hpform.newitem.url"></el-input>
                </div>
                <div class="vCenter">
                  <div class="hptitlelab">dappid：</div>
                  <el-input placeholder="请输入dappid(没有可不填)" v-model="hpform.newitem.dappid"></el-input>
                </div>
                <div class="vCenter">
                  <div class="hptitlelab">appid：</div>
                  <el-input placeholder="请输入appid(没有可不填)" v-model="hpform.newitem.appid"></el-input>
                </div>
                <div class="newsubmitdiv vCenter">
                  <el-button size="mini" @click="hpform.showNewView=false">取消</el-button>
                  <el-button size="mini" type="primary" @click="addNewHpItem()">确定</el-button>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="createtype=='copyhomepage'" class="clearfix">
          <el-form ref="hpform" :model="hpform" label-width="120px">
            <el-form-item label="请选择组织">
              <el-select
                :popper-append-to-body="false"
                v-model="hpform.curorgid"
                placeholder="请选择已创建的组织"
              >
                <el-option
                  v-for="item in hpform.mineorg"
                  :key="item.orgid"
                  :label="item.name"
                  :value="item.orgid"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="已选项目">
              <div v-for="(item,index) in hpform.navlist" :key="index">
                <div>
                  <el-checkbox
                    style="width: 140px;"
                    :checked="item.checked"
                    @change="curHpItemCheckedChange(index)"
                  >{{item.sname}}</el-checkbox>
                  <el-button type="text" @click="editHpItem(item, index)">编辑</el-button>
                  <el-button type="text" @click="delHpItem(index)">删除</el-button>
                </div>
                <div class="newview" v-show="hpform.curindex == index">
                  <div class="vCenter">
                    <div class="hptitlelab">项目名称：</div>
                    <el-input placeholder="请输入项目名称" v-model="hpform.edititem.caption"></el-input>
                  </div>
                  <div class="vCenter">
                    <div class="hptitlelab">项目类型：</div>
                    <el-radio-group v-model="hpform.edititem.itype">
                      <el-radio label="0">网页url</el-radio>
                      <el-radio label="1">自定义页面</el-radio>
                      <el-radio label="2">独立网页</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="vCenter">
                    <div class="hptitlelab">项目地址：</div>
                    <el-input placeholder="请输入项目地址" v-model="hpform.edititem.url"></el-input>
                  </div>
                  <div class="vCenter">
                    <div class="hptitlelab">dappid：</div>
                    <el-input placeholder="请输入dappid(没有可不填)" v-model="hpform.edititem.dappid"></el-input>
                  </div>
                  <div class="vCenter">
                    <div class="hptitlelab">appid：</div>
                    <el-input placeholder="请输入appid(没有可不填)" v-model="hpform.edititem.appid"></el-input>
                  </div>
                  <div class="newsubmitdiv vCenter">
                    <el-button size="mini" @click="hpform.curindex = -1">取消</el-button>
                    <el-button size="mini" type="primary" @click="commitEditHpItem(index)">确定</el-button>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="createtype=='group'" class="clearfix">
          <el-form ref="groupForm" :model="groupForm" label-width="80px">
            <el-form-item label="群头像：" prop="logopath">
              <div class="vCenter">
                <img :src="groupForm.logopath" alt class="logopath" @click="upload1" />
                <div style="margin-left:20px;flex:1">
                  <p>点击头像进行选择，点击上传按钮可上传本地图片。</p>
                  <ul class="clearfix chooselist">
                    <li class="fl">
                      <um-img
                        @submit-file="confirmgroup($event,'group')"
                        :submitStatus="submitImgStatus"
                        v-on:getImgSrc="groupImg"
                        :uploadlogo="groupupload"
                      ></um-img>
                    </li>
                    <li v-for="item in defaultIcon1" class="fl">
                      <img :src="item.path" alt @click="choosecolor(item,'g')" />
                      <img
                        src="/img/select.png"
                        alt
                        class="selectcolor"
                        v-show="item.id==selectcolor"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="群名称：" prop="groupname">
              <el-input v-model="groupForm.groupname"></el-input>
            </el-form-item>
            <el-form-item label="群类型：" prop="grouptype">
              <el-select :popper-append-to-body="false" v-model="groupForm.grouptype">
                <el-option label="普通群" value="0"></el-option>
                <el-option label="内部群" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="群介绍：" prop="groupinfo">
              <el-input type="textarea" v-model="groupForm.groupinfo"></el-input>
            </el-form-item>
            <el-form-item label="群成员：">
              <el-tag
                v-for="(item,index) in tagsFriend"
                :key="index"
                closable
                @close="handleClose(item,index)"
              >{{item.name}}</el-tag>
              <div class="adduser" @click="opencandidate('13')">+添加</div>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="createtype=='dapp'" class="clearfix dapp">
          <el-form ref="formdapp" :model="formdapp" label-width="80px">
            <el-form-item label="LOGO" prop="imageUrl">
              <div class="vCenter">
                <img :src="formdapp.imageUrl" alt class="logopath" @click="upload1" />
                <div style="margin-left:20px;flex:1">
                  <p>点击头像进行选择，点击上传按钮可上传本地图片。</p>
                  <ul class="clearfix chooselist">
                    <li class="fl">
                      <um-img
                        @submit-file="confirmgroup($event,'dapp')"
                        :submitStatus="submitImgStatus"
                        v-on:getImgSrc="dappImg"
                        :uploadlogo="dappupload"
                      ></um-img>
                    </li>
                    <li v-for="item in defaultIcon2" class="fl">
                      <img :src="item.path" alt @click="choosecolor(item,'d')" />
                      <img
                        src="/img/select.png"
                        alt
                        class="selectcolor"
                        v-show="item.id==selectcolor"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="小程序名" required class="newappname" prop="newtitle">
              <el-input v-model="formdapp.newtitle"></el-input>
            </el-form-item>
            <el-form-item label="功能描述" prop="appinfo">
              <el-input type="textarea" v-model="formdapp.appinfo"></el-input>
            </el-form-item>
            <el-form-item label="模板" prop="type">
              <el-select
                :popper-append-to-body="false"
                v-model="formdapp.dappmodule"
                @change="getdappstyle(formdapp.dappmodule)"
                placeholder="请选择模板"
              >
                <el-option
                  v-for="(item,index) in dappmodulelist"
                  :key="index"
                  :label="item.stype"
                  :value="item.sid"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模板样式" prop="type">
              <el-select
                :popper-append-to-body="false"
                v-model="formdapp.istyle"
                placeholder="请选择类型"
                :disabled="formdapp.dappmodule=='58c66a66240c07432a41691e2b6f1a7b'&&formdapp.istyle=='c9a4ae48acfd67565bc1ea5706bf5c4d'"
              >
                <el-option
                  v-for="(item,index) in dappstylelist"
                  :key="index"
                  :label="item.sname"
                  :value="item.sid"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="formdapp.dappmodule=='58c66a66240c07432a41691e2b6f1a7b'"
              label="URL"
              class="newauthor"
              prop="url"
            >
              <el-input v-model="formdapp.dappsrc" placeholder="https://"></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="type">
              <el-select :popper-append-to-body="false" v-model="formdapp.type" placeholder="请选择分类">
                <el-option
                  v-for="(item,index) in dapptypelist1"
                  :key="index"
                  :label="item.sname"
                  :value="item.itype"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="新建人" class="newauthor" prop="newauthor">
              <el-input v-model="formdapp.newauthor" :disabled="true"></el-input>
            </el-form-item>
            <um-identity :formdapp="formdapp" @selectOrg="selectOrgFun"></um-identity>
            <um-range
              :formdapp="formdapp"
              @opencandidate="opencandidateFun"
              :tagsFriend="tagsFriend"
              :tagsGroup="tagsGroup"
              :tagsOrg="tagsOrg"
              :tagshy="tagshy"
              :tagsdq="tagsdq"
            ></um-range>
          </el-form>
        </div>
        <div v-if="createtype=='copydapp'">
          <el-form ref="formdapp" :model="formdapp" label-width="80px">
            <el-form-item label="LOGO" prop="imageUrl">
              <div class="vCenter">
                <img :src="formdapp.imageUrl" alt class="logopath" @click="upload1" />
                <div style="margin-left:20px;flex:1">
                  <p>点击头像进行选择，点击上传按钮可上传本地图片。</p>
                  <ul class="clearfix chooselist">
                    <li class="fl">
                      <um-img
                        @submit-file="confirmgroup($event,'copydapp')"
                        :submitStatus="submitImgStatus"
                        v-on:getImgSrc="dappImg"
                        :uploadlogo="dappupload"
                      ></um-img>
                    </li>
                    <li v-for="item in defaultIcon2" class="fl">
                      <img :src="item.path" alt @click="choosecolor(item,'d')" />
                      <img
                        src="/img/select.png"
                        alt
                        class="selectcolor"
                        v-show="item.id==selectcolor"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="小程序名" required class="newappname" prop="newtitle">
              <el-input v-model="formdapp.newtitle"></el-input>
              <!-- <span v-if="formdapp.title">原小程序名：{{formdapp.title}}</span> -->
            </el-form-item>
            <el-form-item label="功能描述" prop="appinfo">
              <el-input type="textarea" v-model="formdapp.appinfo"></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="type">
              <el-select :popper-append-to-body="false" v-model="formdapp.type" placeholder="请选择分类">
                <el-option
                  v-for="(item,index) in dapptypelist1"
                  :key="index"
                  :label="item.sname"
                  :value="item.itype"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="新建人" class="newauthor" prop="newauthor">
              <el-input v-model="formdapp.newauthor" :disabled="true"></el-input>
              <!-- <span v-if="formdapp.author">原作者：{{formdapp.author}}</span> -->
            </el-form-item>
            <um-identity :formdapp="formdapp" @selectOrg="selectOrgFun"></um-identity>
            <um-range
              :formdapp="formdapp"
              @opencandidate="opencandidateFun"
              :tagsFriend="tagsFriend"
              :tagsGroup="tagsGroup"
              :tagsOrg="tagsOrg"
              :tagshy="tagshy"
              :tagsdq="tagsdq"
            ></um-range>
          </el-form>
        </div>
        <div v-if="createtype=='editdapp'">
          <el-form ref="formdapp" :model="formdapp" label-width="80px">
            <el-form-item label="LOGO" prop="imageUrl">
              <div class="vCenter">
                <img :src="formdapp.imageUrl" alt class="logopath" @click="upload1" />
                <div style="margin-left:20px;flex:1">
                  <p>点击头像进行选择，点击上传按钮可上传本地图片。</p>
                  <ul class="clearfix chooselist">
                    <li class="fl">
                      <um-img
                        @submit-file="confirmgroup($event,'editdapp')"
                        :submitStatus="submitImgStatus"
                        v-on:getImgSrc="dappImg"
                        :uploadlogo="dappupload"
                      ></um-img>
                    </li>
                    <li v-for="item in defaultIcon2" class="fl">
                      <img :src="item.path" alt @click="choosecolor(item,'d')" />
                      <img
                        src="/img/select.png"
                        alt
                        class="selectcolor"
                        v-show="item.id==selectcolor"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="小程序名" required class="newappname" prop="newtitle">
              <el-input v-model="formdapp.newtitle"></el-input>
            </el-form-item>
            <el-form-item label="功能描述" prop="appinfo">
              <el-input type="textarea" v-model="formdapp.appinfo"></el-input>
            </el-form-item>
            <el-form-item label="模板" prop="type">
              <el-select
                :popper-append-to-body="false"
                v-model="formdapp.dappmodule"
                @change="getdappstyle(formdapp.dappmodule)"
                placeholder="请选择模板"
              >
                <el-option
                  v-for="(item,index) in dappmodulelist"
                  :key="index"
                  :label="item.stype"
                  :value="item.sid"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模板样式" prop="type">
              <el-select
                v-model="formdapp.istyle"
                placeholder="请选择类型"
                :disabled="formdapp.dappmodule=='58c66a66240c07432a41691e2b6f1a7b'&&formdapp.istyle=='c9a4ae48acfd67565bc1ea5706bf5c4d'"
              >
                <el-option
                  v-for="(item,index) in dappstylelist"
                  :key="index"
                  :label="item.sname"
                  :value="item.sid"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="formdapp.dappmodule=='58c66a66240c07432a41691e2b6f1a7b'"
              label="URL"
              class="newauthor"
              prop="url"
            >
              <el-input v-model="formdapp.dappsrc" placeholder="https://"></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="type">
              <el-select :popper-append-to-body="false" v-model="formdapp.type" placeholder="请选择分类">
                <el-option
                  v-for="(item,index) in dapptypelist1"
                  :key="index"
                  :label="item.sname"
                  :value="item.itype"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="新建人" class="newauthor" prop="newauthor">
              <el-input v-model="formdapp.author" :disabled="true"></el-input>
            </el-form-item>
            <um-identity :formdapp="formdapp" @selectOrg="selectOrgFun"></um-identity>
            <um-range
              :formdapp="formdapp"
              @opencandidate="opencandidateFun"
              :tagsFriend="tagsFriend"
              :tagsGroup="tagsGroup"
              :tagsOrg="tagsOrg"
              :tagshy="tagshy"
              :tagsdq="tagsdq"
            ></um-range>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="createtype!='user'">
        <el-button @click="closenew()">取 消</el-button>
        <el-button
          type="primary"
          :disabled="!submitStatus"
          @click="confirmhomepage(createtype)"
          v-if="createtype=='homepage'"
        >{{submitBtn}}</el-button>
        <el-button
          type="primary"
          :disabled="!submitStatus"
          @click="confirm(createtype)"
          v-else
        >{{submitBtn}}</el-button>
      </span>
    </el-dialog>
    <um-candidate
      :chooseorg="chooseorg"
      :hy="tagshy"
      :dq="tagsdq"
      @closecandidate="closecandidateFun"
      :createtype="createtype"
      :friend="tagsFriend"
      :org="tagsOrg"
      :group="tagsGroup"
      @submitcandidate="submitcandidateFun"
      v-if="candidate"
      :usertype="usertype"
      :candidate="candidate"
    ></um-candidate>
  </div>
</template>
  <script>
import { mm, search, setad } from "./map";
export default {
  name: "umAddlist",
  data() {
    return {
      checkArray: [],
      total: 0,
      groupForm: {
        groupname: "",
        grouptype: "0",
        groupinfo: "",
        logopath: "/img/default/group/defaultIcon1.png"
      },
      groupupload: "",
      orgid: "",
      dappupload: "",
      orgupload: "",
      defaultIcon: [
        { id: 1, path: "/img/default/org/defaultIcon1.png" },
        { id: 2, path: "/img/default/org/defaultIcon2.png" },
        { id: 3, path: "/img/default/org/defaultIcon3.png" },
        { id: 4, path: "/img/default/org/defaultIcon4.png" },
        { id: 5, path: "/img/default/org/defaultIcon5.png" },
        { id: 6, path: "/img/default/org/defaultIcon6.png" },
        { id: 7, path: "/img/default/org/defaultIcon7.png" },
        { id: 8, path: "/img/default/org/defaultIcon8.png" },
        { id: 9, path: "/img/default/org/defaultIcon9.png" },
        { id: 10, path: "/img/default/org/defaultIcon10.png" },
        { id: 11, path: "/img/default/org/defaultIcon11.png" },
        { id: 12, path: "/img/default/org/defaultIcon12.png" }
      ],
      defaultIcon1: [
        { id: 1, path: "/img/default/group/defaultIcon1.png" },
        { id: 2, path: "/img/default/group/defaultIcon2.png" },
        { id: 3, path: "/img/default/group/defaultIcon3.png" },
        { id: 4, path: "/img/default/group/defaultIcon4.png" },
        { id: 5, path: "/img/default/group/defaultIcon5.png" },
        { id: 6, path: "/img/default/group/defaultIcon6.png" },
        { id: 7, path: "/img/default/group/defaultIcon7.png" },
        { id: 8, path: "/img/default/group/defaultIcon8.png" },
        { id: 9, path: "/img/default/group/defaultIcon9.png" },
        { id: 10, path: "/img/default/group/defaultIcon10.png" },
        { id: 11, path: "/img/default/group/defaultIcon11.png" },
        { id: 12, path: "/img/default/group/defaultIcon12.png" }
      ],
      defaultIcon2: [
        { id: 1, path: "/img/default/dapp/defaultIcon1.png" },
        { id: 2, path: "/img/default/dapp/defaultIcon2.png" },
        { id: 3, path: "/img/default/dapp/defaultIcon3.png" },
        { id: 4, path: "/img/default/dapp/defaultIcon4.png" },
        { id: 5, path: "/img/default/dapp/defaultIcon5.png" },
        { id: 6, path: "/img/default/dapp/defaultIcon6.png" },
        { id: 7, path: "/img/default/dapp/defaultIcon7.png" },
        { id: 8, path: "/img/default/dapp/defaultIcon8.png" },
        { id: 9, path: "/img/default/dapp/defaultIcon9.png" },
        { id: 10, path: "/img/default/dapp/defaultIcon10.png" },
        { id: 11, path: "/img/default/dapp/defaultIcon11.png" },
        { id: 12, path: "/img/default/dapp/defaultIcon12.png" }
      ],
      candidate: false,
      usertype: [],
      tagsFriend: [],
      tagsOrg: [],
      tagsGroup: [],
      tagshy: [],
      tagsdq: [],
      showRightList: -1,
      selectcolor: 1,
      value: 0,
      showid: false,
      options: [
        {
          value: 0,
          label: "普通群"
        },
        {
          value: 1,
          label: "部门群"
        }
      ],
      actaddress: "",
      address: {
        province: "",
        city: "",
        area: ""
      },
      adduserText: "好友推荐",
      tabactiveid: 0,
      userlist: [
        { avatar: "", sumname: "蔡威泽", sphone: "17825449615" },
        {
          avatar: "",
          sumname: "蔡威泽",
          job: "web前端可开发工程师",
          company: "青岛天狗物联科技有限公司",
          sphone: "17825449615"
        },
        {
          avatar: "",
          sumname: "蔡威泽",
          job: "web前端可开发工程师",
          company: "青岛天狗物联科技有限公司",
          sphone: "17825449615"
        },
        {
          sumname: "蔡威泽",
          job: "web前端可开发工程师",
          company: "青岛天狗物联科技有限公司",
          sphone: "17825449615"
        }
      ],
      isphone: false,
      isfriend: false,
      searchText: "",
      validationMsg: "",
      rules: {
        orgname: [{ required: true, message: "组织名称", trigger: "blur" }],
        value: [{ required: true, message: "组织类型", trigger: "change" }]
      },
      dialogInfo: {},
      mine: 0,
      submitBtn: "立即创建",
      strangermsg: 1,
      submitImgStatus: false,
      sNum: 0,
      squarelist: [
        {
          name: "推荐",
          id: 0,
          list: [],
          total: 1,
          shownum: 8,
          page: 0
        },
        {
          name: "共同好友",
          id: 1,
          list: [],
          total: 1,
          shownum: 8,
          page: 0
        },
        {
          name: "同城",
          id: 2,
          list: [],
          total: 1,
          shownum: 8,
          page: 0
        },
        { name: "同乡", id: 3, list: [], total: 1, shownum: 8, page: 0 },

        {
          name: "同行",
          id: 4,
          list: [],
          total: 1,
          shownum: 8,
          page: 0
        },
        {
          name: "校友",
          id: 5,
          list: [],
          total: 1,
          shownum: 8,
          page: 0
        }
      ],
      squarelist2: [
        {
          name: "群推荐",
          id: 1,
          list: [],
          total: 1,
          shownum: 8,
          page: 0
        }
      ],
      squarelist1: [
        {
          name: "组织推荐",
          id: 1,
          list: [],
          total: 1,
          shownum: 8,
          page: 0
        }
      ],
      apply_group: false,
      apply_org: false,
      validationGroupMsg: "",
      validationOrgMsg: "",
      applyroomid: 0,
      applyorgid: 0,
      gxtype: 0,
      searchBoxshow: false,
      searchuserlist: [],
      squaretab: [
        { id: 0, name: "找人" },
        { id: 1, name: "找组织" },
        { id: 2, name: "找群组" }
        // {id:3,name:'找服务'},
        // {id:4,name:'找商机'}
      ],
      setad: Object,
      setstatus: false,
      next: false,
      dappmodulelist: [],
      dappstylelist: [],
      dapptypelist1: []
    };
  },
  mounted() {
    var that = this;
    if (that.choosedtype) {
      that.usertype = [...that.choosedtype];
    }
    that.mine = $UMCore.uncompile("umid");
    that.squarelistFun(0);
    that.squarelistFun1(0);
    that.squarelistFun2(0);
    var m = {
      editorginfo(ummsg) {
        that.submitBtn = "立即修改";
        that.setad = {
          province: ummsg.data.orginfo.province,
          city: ummsg.data.orginfo.city,
          district: ummsg.data.orginfo.area
        };
        that.setstatus = true;
      }
    };
    $UMCore.on(["org"], m);
    that.tagsFriend = [];
    that.tagsFriend.push({
      id: $UMCore.uncompile("umid"),
      name: $UMCore.uncompile("sumname")
    });
    if (this.formdapp) {
      that.getdappModule();
      that.getdappsquare();
    }
  },
  props: [
    "searchUserText",
    "unionStatus",
    "gxorgid",
    "chooseorg",
    "customClass",
    "addDailog",
    "groupTitle",
    "form",
    "formdapp",
    "createtype",
    "submitStatus",
    "fileinfo",
    "address",
    "hpform",
    "toumid",
    "toname",
    "showPeople",
    "choosedtype"
  ],
  watch: {
    form: {
      handler(newval, oldval) {
        if(this.addDailog){
          if (newval.logopath && newval.logopath != "") {
            for (var i = 1; i < this.defaultIcon.length; i++) {
              if (this.defaultIcon[i - 1].path == newval.logopath) {
                this.selectcolor = i;
                break;
              } else {
                this.selectcolor = -1;
              }
            }
          }
        }
      },
      immediate: true,
      deep: true
    },
    formdapp: {
      handler(newval, oldval) {
        if(this.addDailog){
          if (newval.logopath && newval.logopath != "") {
            for (var i = 1; i < this.defaultIcon2.length; i++) {
              if (this.defaultIcon2[i - 1].path == newval.logopath) {
                this.selectcolor = i;
                break;
              } else {
                this.selectcolor = -1;
              }
            }
          }
        }
      },
      immediate: true,
      deep: true
    },
    searchUserText: {
      handler(newval, oldval) {
        this.searchText = newval;
        if (this.searchText != "") {
          this.searchfriends();
        } else {
          this.squarelistFun(0);
        }
      },
      immediate: true,
      deep: true
    },
    active: {
      handler(newval, oldval) {
        if (newval) {
          this.tabactiveid = newval;
          this.changetab(newval);
        } else {
          this.tabactiveid = 0;
          this.changetab(0);
        }
      },
      immediate: true,
      deep: true
    },
    "formdapp.dappmodule": {
      handler(newval, oldval) {
        if (newval == "58c66a66240c07432a41691e2b6f1a7b") {
          this.formdapp.istyle = "c9a4ae48acfd67565bc1ea5706bf5c4d";
        } else {
          if (this.dappstylelist.length > 0) {
            this.formdapp.istyle = this.dappstylelist[0].sid;
          }
        }
      },
      immediate: false,
      deep: true
    },
    addDailog: {
      handler(newval, oldval) {
        this.submitImgStatus = false;
        if (newval && this.createtype == "org") {
          // console.log(74526,mm)
          mm(this.customClass, this.setstatus, this.setad);
        }
        if (
          (newval && this.createtype == "dapp") ||
          (newval && this.createtype == "copydapp") ||
          (newval && this.createtype == "editdapp")
        ) {
          // console.log(74526,mm)
          this.tagsFriend = [];
          this.tagsGroup = [];
          this.tagshy = [];
          this.tagsdq = [];
        }
        if (this.createtype == "editdapp") {
          this.submitBtn = "提交";
          if (this.formdapp.rangelist) {
            this.formdapp.rangelist.forEach(m => {
              if (m.type == "21") {
                this.tagsFriend.push({
                  name: m.name,
                  id: m.items
                });
              } else if (m.type == "22") {
                this.tagsGroup.push({
                  name: m.name,
                  id: m.items
                });
              } else if (m.type == "31") {
                this.tagshy.push({
                  name: m.name,
                  code: m.items,
                  id: m.extid
                });
              } else if (m.type == "41") {
                this.tagsdq.push({
                  name: m.name,
                  code: m.items,
                  id: m.extid
                });
              }
            });
          }
        } else if (this.createtype == "copydapp") {
          this.submitBtn = "立即复制";
        } else if (this.createtype == "dapp") {
          this.submitBtn = "立即创建";
        }
      },
      immediate: true,
      deep: true
    },
    toumid() {
      this.tagsFriend = [];
      this.tagsFriend.push(
        { id: $UMCore.uncompile("umid"), name: $UMCore.uncompile("sumname") },
        { id: this.toumid, name: this.toname }
      );
    },
    showPeople: {
      handler(newval, oldval) {
        this.candidate = newval;
      },
      deep: true
    }
  },
  methods: {
    rightList(i, event) {
      this.showRightList = i;
    },
    rightListhide() {
      (this.showRightList = -1), (this.status = -1);
    },
    selectOrgFun(orgid, identitytype) {
      if (identitytype == "1") {
        this.formdapp.item = $UMCore.uncompile("umid");
      } else {
        this.formdapp.item = orgid;
      }
    },
    opencandidateFun(type) {
      this.candidate = true;
      this.usertype = [...type];
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getdappModule() {
      $UMCore
        .post("/route.lua", {
          data: JSON.stringify({
            protocoltype: 3,
            address: {},
            operation: { prot_opercode: -13 },
            protocol: {}
          })
        })
        .then(res => {
          this.dappmodulelist = res.data.dappmodule;
          this.formdapp.dappmodule = this.dappmodulelist[0].sid;
          this.getdappstyle(this.formdapp.dappmodule);
        });
    },
    getdappsquare() {
      $UMCore
        .post("/route.lua", {
          data: JSON.stringify({
            modulename: "dapplist",
            functionname: "dapp_getdappsquaretype"
          })
        })
        .then(res => {
          this.dapptypelist = res.data.data.dappsquaretype;
          var a = JSON.parse(JSON.stringify(this.dapptypelist));
          a.shift();
          this.dapptypelist1 = a;
          this.formdapp.type = this.dapptypelist1[0].itype;
        })
        .catch(error => {});
    },
    getdappstyle(modid) {
      $UMCore
        .post("/route.lua", {
          data: JSON.stringify({
            protocoltype: 3,
            address: {},
            operation: { prot_opercode: -14 },
            protocol: {
              itype: 1,
              modid: modid
            }
          })
        })
        .then(res => {
          this.dappstylelist = res.data.dappstyle;
          this.formdapp.istyle = this.dappstylelist[0].sid;
        });
    },
    search1(data) {
      search(data);
    },
    changetab(id) {
      this.tabactiveid = id;
      this.searchBoxshow = false;
    },
    hidenum(num) {
      return num.substr(0, 3) + "****" + num.substr(7);
    },
    sizeChange(val, id) {
      this.squarelistFun(id, val);
    },
    sizeChange1(val, id) {
      this.squarelistFun1(id, val);
    },
    sizeChange2(val, id) {
      this.squarelistFun2(id, val);
    },
    squarelistmore(itype) {
      if (
        this.squarelist[itype - 1].shownum == 8 &&
        this.squarelist[itype - 1].list.length > 8
      ) {
        this.squarelist[itype - 1].shownum = 20;
      } else {
        this.squarelist[itype - 1].shownum = 8;
      }
    },
    squarelistmore1(itype) {
      if (
        this.squarelist1[itype - 1].shownum == 8 &&
        this.squarelist1[itype - 1].list.length > 8
      ) {
        this.squarelist1[itype - 1].shownum = 20;
      } else {
        this.squarelist1[itype - 1].shownum = 8;
      }
    },
    squarelistmore2(itype) {
      if (
        this.squarelist2[itype - 1].shownum == 8 &&
        this.squarelist2[itype - 1].list.length > 8
      ) {
        this.squarelist2[itype - 1].shownum = 20;
      } else {
        this.squarelist2[itype - 1].shownum = 8;
      }
    },
    squarelistFun(itype, currentpage) {
      var itype = itype,
        page;
      if (itype == 0) {
        page = 0;
      } else {
        this.squarelist[itype-1].page = currentpage - 1;
        page = this.squarelist[itype-1].page;
      }
      $UMCore
        .post("/route.lua", {
          data: JSON.stringify({
            functionname: "userlist_square",
            umid: $UMCore.uncompile("umid"),
            itype: itype,
            pagesize: 20,
            page: page
          })
        })
        .then(res => {
          if (itype == 0) {
            this.squarelist[0].list = res.data.slist.recommend;
            this.squarelist[1].list = res.data.slist.sfriends;
            this.squarelist[1].total = res.data.slist.sfriendpagesize;
            this.squarelist[2].list = res.data.slist.arealist;
            this.squarelist[2].total = res.data.slist.areapagesize;
            this.squarelist[4].list = res.data.slist.sjobs;
            this.squarelist[4].total = res.data.slist.jobpagesize;
            this.squarelist[3].list = res.data.slist.homelist;
            this.squarelist[3].total = res.data.slist.homepagesize;
            this.squarelist[5].list = res.data.slist.schoollist;
            this.squarelist[5].total = res.data.slist.schoolpagesize;
          } else if (itype == 1) {
            this.squarelist[1].list = res.data.slist.sfriends;
            this.squarelist[1].total = res.data.slist.sfriendpagesize;
          }  else if (itype == 2) {
            this.squarelist[2].list = res.data.slist.arealist;
            this.squarelist[2].total = res.data.slist.areapagesize;
          } else if (itype == 3) {
            this.squarelist[3].list = res.data.slist.homelist;
            this.squarelist[3].total = res.data.slist.homepagesize;
          } else if (itype == 4) {
            this.squarelist[4].list = res.data.slist.sjobs;
            this.squarelist[4].total = res.data.slist.jobpagesize;
          }  else if (itype == 5) {
            this.squarelist[5].list = res.data.slist.schoollist;
            this.squarelist[5].total = res.data.slist.schoolpagesize;
          }
        });
    },
    squarelistFun1(itype, currentpage) {
      var itype = itype,
        page;
      if (itype == 0) {
        page = 0;
      } else if (itype == 1) {
        this.squarelist1[0].page = currentpage - 1;
        page = this.squarelist1[0].page;
      } else if (itype == 3) {
        this.squarelist1[2].page = currentpage - 1;
        page = this.squarelist1[2].page;
      }
      $UMCore
        .post("/route.lua", {
          data: JSON.stringify({
            functionname: "org_srhorg",
            modulename: "org",
            umid: $UMCore.uncompile("umid"),
            itype: 0,
            pagelimit: 20,
            page: page
          })
        })
        .then(res => {
          this.squarelist1[0].list = res.data.data.slist;
          this.squarelist1[0].total = res.data.data.total;
        });
    },
    squarelistFun2(itype, currentpage) {
      var itype = itype,
        page;
      if (itype == 0) {
        page = 0;
      } else if (itype == 1) {
        this.squarelist2[0].page = currentpage - 1;
        page = this.squarelist2[0].page;
      } else if (itype == 3) {
        this.squarelist2[2].page = currentpage - 1;
        page = this.squarelist2[2].page;
      }
      $UMCore
        .post("/route.lua", {
          data: JSON.stringify({
            functionname: "room_srhroom",
            modulename: "room",
            umid: $UMCore.uncompile("umid"),
            itype: 0,
            pagelimit: 20,
            page: page
          })
        })
        .then(res => {
          this.squarelist2[0].list = res.data.data.slist;
          this.squarelist2[0].total = res.data.data.total;
        });
    },
    applyappid() {
      $UMCore
        .post("/route.lua", {
          data: JSON.stringify({
            functionname: "dapp_getappid",
            modulename: "dapplist"
          })
        })
        .then(response => {
          if (response.data.code == 0) {
            this.formdapp.appid = response.data.data;
          }
        })
        .catch(error => {});
    },
    upload1() {
      $("." + this.customClass + " .chooselist .el-upload").click();
    },
    showchangeFun() {
      this.showid = false;
    },
    opencandidate(type) {
      this.showPeople = true;
      this.usertype = [...type];
    },
    closecandidateFun(f, g, o, h, d) {
      this.showPeople = false;
      this.candidate = false;
      this.tagsFriend = f;
      this.tagsGroup = g;
      this.tagsOrg = o;
      this.tagshy = h;
      this.tagsdq = d;
      this.$emit("peopleStatus", this.showPeople);
    },
    submitcandidateFun(f, g, o, h, d) {
      this.tagsFriend = f;
      this.tagsGroup = g;
      this.tagsOrg = o;
      this.tagshy = h;
      this.tagsdq = d;
      this.showPeople = false;
      this.candidate = false;
      this.$emit("peopleStatus", this.showPeople);
      if (this.createtype == "audiochat" || this.createtype == "videochat") {
        let arr = [];
        f.forEach(val => {
          if (val.id) {
            arr.push(val.id);
          }
        });
        o.forEach(val => {
          if (val.id) {
            arr.push(val.id);
          }
        });
        this.$emit("voiceCallUser", arr);
      }
      console.log(f, g, o);
    },
    choosecolor(item, type) {
      this.selectcolor = item.id;
      if (type == "g") {
        this.groupForm.logopath = item.path;
      } else if (type == "o") {
        this.form.logopath = item.path;
      } else if (type == "d") {
        this.formdapp.imageUrl = item.path;
      }
    },
    groupImg(val) {
      if (this.groupupload == "") {
        this.groupupload = undefined;
      } else {
        this.groupupload = "";
      }
      this.groupForm.logopath = val;
      this.selectcolor = -1;
    },
    orgImg(val) {
      if (this.orgupload == "") {
        this.orgupload = undefined;
      } else {
        this.orgupload = "";
      }
      this.form.logopath = val;
      this.selectcolor = -1;
    },
    dappImg(val) {
      if (this.dappupload == "") {
        this.dappupload = undefined;
      } else {
        this.dappupload = "";
      }
      this.formdapp.imageUrl = val;
      this.selectcolor = -1;
    },
    /**
     * 选人组件向父组件传值
     */
    checkFun(data, total) {
      var index = -1;
      if (this.checkArray.length > 0) {
        this.checkArray.forEach((m, i) => {
          if (m.id == data.id) {
            index = i;
          }
        });
        if (index != -1) {
          this.checkArray.splice(index, 1);
        } else {
          this.checkArray.push(data);
        }
      } else {
        this.checkArray.push(data);
      }
      this.total = total;
    },
    /**上传图片 */
    receiveChildSum(src) {
      this.fileinfo = src.path;
    },
    avaname(name) {
      return name.substr(name.length - 2, 2);
    },
    setvalue() {
      this.validationMsg = "我是";
    },
    /**tag表签删除 */
    handleClose(item, index) {
      this.tagsFriend.splice(index, 1);
    },
    selectProvince(value) {
      this.address.province = value.value;
    },
    selectCity(value) {
      this.address.city = value.value;
    },
    selectArea(value) {
      this.address.area = value.value;
    },
    /**拼接地址 */
    onSelectedAddress(data) {
      this.actaddress =
        data.province.value + "-" + data.city.value + "-" + data.area.value;
    },
    receiveImgSrc(val) {
      this.form.companybackground = val;
    },
    /**关闭弹窗操作 */
    closenew() {
      var that = this;
      that.setstatus = false;
      that.setad = {};
      that.addDailog = false;
      that.submitBtn = "立即创建";
      that.groupTitle = "";
      if (that.createtype == "group") {
        that.tagsFriend = [];
        that.tagsFriend.push({
          id: $UMCore.uncompile("umid"),
          name: $UMCore.uncompile("sumname")
        });
        that.groupname = "";
        that.selectcolor = 1;
        this.$refs["groupForm"].resetFields();
        that.value = 0;
      } else if (that.createtype == "org") {
        that.form.orgname = "";
        that.form.orgshortname = "";
        that.form.orghomepage = "";
        that.form.orgemial = "";
        that.form.orgdesc = "";
        that.form.orgtel = "";
        that.form.value = "1";
        that.address.province = "";
        that.form.companybackground = "";
        that.address.city = "";
        that.address.area = "";
        that.$refs["form"].resetFields();
        that.selectcolor = 1;
      } else if (that.createtype == "user") {
        that.searchBoxshow = false;
        that.searchText = that.searchUserText;
        if (that.searchText == "") {
          that.squarelistFun(0);
        } else {
          that.searchfriends();
        }
      } else if (
        that.createtype == "dapp" ||
        that.createtype == "copydapp" ||
        that.createtype == "editdapp"
      ) {
        that.resetForm("formdapp");
        that.formdapp.newtitle = "";
        that.formdapp.appinfo = "";
        that.formdapp.rangetype = "1";
        that.formdapp.rangelist = [];
        that.formdapp.identitytype = "1";
        that.formdapp.item = "";
        that.formdapp.imageUrl = "/img/default/dapp/defaultIcon1.png";
        that.getdappModule();
        that.getdappsquare();
      }
      that.$emit("closenew", that.addDailog);
    },
    confirm() {
      this.submitImgStatus = true;
    },
    confirmhomepage(t) {
      if (t == "homepage") {
        this.$emit("confirmhomepage", this.hpform);
      } else if (t == "copyhomepage") {
        if (this.hpform.curorgid == "0") {
          this.$message.error("请选择正确的组织！");
          return false;
        }
        this.hpform.mineorg.forEach((m, i) => {
          if (m.orgid == this.hpform.curorgid) {
            this.hpform.curhomepage = m.homepage;
          }
        });
        if (this.hpform.curhomepage != "" && this.hpform.curhomepage != "nil") {
          this.$confirm(
            "该组织已经存在主页，此操作将替换主页, 是否继续?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
            .then(() => {
              this.hpform.orgid = this.hpform.curorgid;
              this.$emit("confirmhomepage", this.hpform);
            })
            .catch(() => {
              this.submitStatus = true;
            });
        } else {
          this.hpform.orgid = this.hpform.curorgid;
          this.$emit("confirmhomepage", this.hpform);
        }
      }
    },
    confirmgroup(e, t) {
      let that = this;
      this.submitStatus = false;
      this.submitImgStatus = false;
      if (t == "group") {
        if (e != "") {
          this.groupForm.logopath = e.fullpath;
        }
        this.$emit("confirmgroup", this.tagsFriend, this.groupForm);
      } else if (t == "dapp" || t == "copydapp" || t == "editdapp") {
        if (e != "") {
          this.formdapp.imageUrl = e.fullpath;
        }
        if (that.formdapp.rangetype == "2") {
          that.formdapp.rangelist = [];
          for (var j = 0; j < that.tagsFriend.length; j++) {
            var tagitem = {};
            tagitem.type = 21;
            tagitem.item = that.tagsFriend[j].umid;
            tagitem.name = that.tagsFriend[j].name;
            that.formdapp.rangelist.push(tagitem);
          }
          for (var j = 0; j < that.tagsGroup.length; j++) {
            var tagitem = {};
            tagitem.type = 22;
            tagitem.item = that.tagsGroup[j].id;
            tagitem.name = that.tagsGroup[j].name;
            that.formdapp.rangelist.push(tagitem);
          }
          for (var j = 0; j < that.tagshy.length; j++) {
            var tagitem = {};
            tagitem.type = 31;
            tagitem.item = that.tagshy[j].code;
            tagitem.name = that.tagshy[j].name;
            tagitem.extid = that.tagshy[j].id;
            that.formdapp.rangelist.push(tagitem);
          }
          for (var j = 0; j < that.tagsdq.length; j++) {
            var tagitem = {};
            tagitem.type = 41;
            tagitem.item = that.tagsdq[j].code;
            tagitem.name = that.tagsdq[j].name;
            tagitem.extid = that.tagsdq[j].id;
            that.formdapp.rangelist.push(tagitem);
          }
          for (var j = 0; j < that.tagsOrg.length; j++) {
            var tagitem = {};
            if (that.tagsOrg[j].type == "2") {
              tagitem.type = 24;
            } else {
              tagitem.type = 23;
            }
            tagitem.item = that.tagsOrg[j].id;
            tagitem.name = that.tagsOrg[j].name;
            that.formdapp.rangelist.push(tagitem);
          }
        }
        this.$emit("confirmdapp", this.formdapp, t);
      }
    },
    confirmgroup1(e, t) {
      if (e != "") {
        this.form.logopath = e.fullpath;
        this.sNum++;
        this.next = true;
      } else {
        this.next = true;
      }
      this.confirmgroup2()
    },
    confirmgroup2() {
      this.actaddress =
        $("." + this.customClass + " #province option:selected").text() +
        "-" +
        $("." + this.customClass + " #city option:selected").text() +
        "-" +
        $("." + this.customClass + " #district option:selected").text();
      if (this.sNum == 1 || this.sNum == 0) {
        if (this.form.logopath == "") {
          this.$message.error("请上传组织logo！");
          this.submitStatus = true;
          this.submitImgStatus = false;
          return false;
        } else if (this.form.orgname == "" || this.form.value == "") {
          this.$message.error("请完整填写必填项！");
          this.submitStatus = true;
          this.submitImgStatus = false;
          return false;
        } else {
          this.sNum = 0;
          this.$emit(
            "confirmorg",
            this.form,
            this.fileinfo,
            this.actaddress
          );
        }
      }
      this.next = false;
    },
    /**
     * 查找好友
     */
    searchfriends() {
      var that = this;
      var data;
      if (that.searchText == "") {
        that.searchBoxshow = false;
      } else {
        if (that.tabactiveid == 0 && !that.unionStatus) {
          data = JSON.stringify({
            modulename: "friends",
            functionname: "sys_user_searchfriend",
            umid: $UMCore.uncompile("umid"),
            swhere: that.searchText,
            page: 0,
            pagesize: 20
          });
        } else if (that.tabactiveid == 1 && !that.unionStatus) {
          data = JSON.stringify({
            modulename: "org",
            functionname: "org_srhorg",
            umid: $UMCore.uncompile("umid"),
            swhere: that.searchText,
            itype: 1,
            page: 0,
            pagesize: 20
          });
        } else if (that.tabactiveid == 2 && !that.unionStatus) {
          data = JSON.stringify({
            modulename: "room",
            functionname: "room_srhroom",
            umid: $UMCore.uncompile("umid"),
            swhere: that.searchText,
            itype: 1,
            page: 0,
            pagesize: 20
          });
        } else if (that.unionStatus) {
          data = JSON.stringify({
            modulename: "org",
            functionname: "org_srhorg",
            umid: $UMCore.uncompile("umid"),
            swhere: that.searchText,
            itype: 1,
            page: 0,
            pagesize: 20,
            orgid: that.gxorgid
          });
        }
      }
      $UMCore
        .post("route.lua", {
          data: data
        })
        .then(function(res) {
          if (res.data.code == 0) {
            console.log(9898, res.data.data.slist);
            if (res.data.data.slist.length > 0) {
              that.searchBoxshow = true;
              that.searchuserlist = res.data.data.slist;
            } else {
              that.$message.error("没找到相符的信息！");
            }
          }
        })
        .catch(function(error) {});
    },
    /**
     * 添加好友弹窗
     */
    addfriend(umid, userinfo, item) {
      var that = this;
      that.$set(that.dialogInfo, "umid", umid);
      that.$set(that.dialogInfo, "item", item);
      $UMCore
        .post("route.lua", {
          data: JSON.stringify({
            modulename: "friends",
            functionname: "sys_user_checkfriend",
            umid: $UMCore.uncompile("umid"),
            toumid: umid
          })
        })
        .then(function(res) {
          if (res.data.code == 0) {
            if (res.data.data.status) {
              that.isfriend = true;
              $UMCore.msg({
                cmd: "iframe",
                op: "openiframe1",
                info: "",
                data: { title: "验证消息", width: "400px", height: "100px" }
              });
            } else {
              that.isfriend = false;
              $UMCore.msg({
                cmd: "iframe",
                op: "openiframe1",
                info: "",
                data: { title: "验证消息", width: "400px", height: "220px" }
              });
            }
            if (that.dialogInfo.umid == that.mine) {
              $UMCore.msg({
                cmd: "iframe",
                op: "openiframe1",
                info: "",
                data: { title: "验证消息", width: "400px", height: "100px" }
              });
            }
            that.showid = true;
          }
        })
        .catch(function(error) {
          that.$message.error("发送验证失败！请重试");
        });
    },
    applygroup(id) {
      var that = this;
      $UMCore.msg({
        cmd: "iframe",
        op: "openiframe1",
        info: "",
        data: {
          title: "验证消息",
          width: "400px",
          height: "220px"
        }
      });
      that.showid = true;
      that.apply_group = true;
      that.apply_org = false;
      that.applyroomid = id;
    },
    applyorg(id, type) {
      var that = this;
      $UMCore.msg({
        cmd: "iframe",
        op: "openiframe1",
        info: "",
        data: {
          title: "验证消息",
          width: "400px",
          height: "220px"
        }
      });
      that.showid = true;
      that.apply_org = true;
      that.apply_group = false;
      that.applyorgid = id;
      that.gxtype = type;
    },

    /**
     * 发送好友申请
     */
    sendApply(id) {
      var that = this,
        applyfrom = "";
      if (that.apply_group && !that.apply_org) {
        $UMCore
          .post("/route.lua", {
            data: JSON.stringify({
              modulename: "room",
              functionname: "room_setuserapply",
              umid: $UMCore.uncompile("umid"),
              roomid: id,
              msg: that.validationGroupMsg
            })
          })
          .then(res => {
            that.showid = false;
            that.$message({
              message: "发送请求成功！",
              type: "success",
              onClose: function() {
                that.validationGroupMsg = "";
              }
            });
          });
      } else if (!that.apply_group && that.apply_org && !that.unionStatus) {
        $UMCore
          .post("/route.lua", {
            data: JSON.stringify({
              modulename: "org",
              functionname: "org_setuserapply",
              umid: $UMCore.uncompile("umid"),
              orgid: id,
              msg: that.validationOrgMsg
            })
          })
          .then(res => {
            that.showid = false;
            that.$message({
              message: "发送请求成功！",
              type: "success",
              onClose: function() {
                that.validationOrgMsg = "";
              }
            });
          });
      } else if (!that.apply_group && that.apply_org && that.unionStatus) {
        $UMCore
          .post("/route.lua", {
            data: JSON.stringify({
              modulename: "org",
              functionname: "org_setorgtoorgapply",
              toorgid: id,
              orgid: that.gxorgid,
              type: that.gxtype,
              msg: that.validationOrgMsg
            })
          })
          .then(res => {
            that.showid = false;
            that.$message({
              message: "发送请求成功！",
              type: "success",
              onClose: function() {
                that.validationOrgMsg = "";
                that.gxtype = 0;
              }
            });
          });
      } else {
        if (that.isphone) {
          applyfrom = "手机号码搜索";
        } else {
          applyfrom = "UMID搜索";
        }
        $UMCore
          .post("route.lua", {
            data: JSON.stringify({
              modulename: "friends",
              functionname: "sys_user_setfriendapply",
              umid: $UMCore.uncompile("umid"),
              toumid: id,
              msg: that.validationMsg,
              desname: that.desname,
              applyfrom: applyfrom
            })
          })
          .then(function(res) {
            if (res.data.code == 0) {
              that.showid = false;
              that.$message({
                message: "发送请求成功！",
                type: "success",
                onClose: function() {
                  (that.validationMsg = ""), (that.desname = "");
                }
              });
            }
          })
          .catch(function(error) {
            that.$message.error("发送验证失败！请重试");
          });
      }
    },
    openchatroom(i) {
      this.showid = false;
      $UMCore.msg({
        cmd: "header",
        op: "type1",
        info: "info",
        data: { type: "message" }
      });
      var user = {
        id: i.roomid,
        avatar: i.logopath,
        name: i.roomname,
        type: "1",
        itype: "2",
        createumid: i.createumid,
        op_type: "roommsg"
      };
      $UMCore.msg({ cmd: "umid", op: "info", info: "info", data: user });
    },

    /**
     *点击发送消息按钮打开互动聊天窗口
     */
    openchat: function(item, type, info) {
      var that = this;
      that.showid = false;
      $UMCore
        .post("route.lua", {
          data: JSON.stringify({
            modulename: "friends",
            functionname: "sys_user_checkfriend",
            umid: $UMCore.uncompile("umid"),
            toumid: info.umid
          })
        })
        .then(function(res) {
          if (res.data.code == 0) {
            if (res.data.data.status) {
              that.strangermsg = 1;
            } else {
              that.strangermsg = 0;
            }
            $UMCore.msg({
              cmd: "header",
              op: "type1",
              info: "info",
              data: { type: "message" }
            });
            if (item && type) {
              that.userinfo = item;
              that.itype = type;
            }
            if (info) {
              var data = {
                userinfo: info,
                caogao: "",
                itype: that.itype,
                op_type: "msg",
                umid: info.umid,
                avatar: info.avatar,
                sumname: info.sumname,
                strangermsg: that.strangermsg
              };
            } else {
              var data = {
                userinfo: that.carduserInfo,
                usersub: that.cardusersub,
                caogao: "",
                itype: that.itype,
                op_type: "msg",
                umid: that.carduserInfo.umid,
                avatar: that.carduserInfo.avatar,
                sumname: that.carduserInfo.sumname,
                strangermsg: that.strangermsg
              };
            }
            $UMCore.msg({ cmd: "umid", op: "info", info: "info", data: data });
            that.addDailog = false;
            that.$emit("closenew", that.addDailog, "chat");
          }
        })
        .catch(function(error) {
          that.$message.error("发送验证失败！请重试");
        });
    },
    curHpItemCheckedChange(index) {
      console.log("curHpItemCheckedChange" + index);
      var that = this;
      if (that.hpform.navlist[index].checked == true) {
        that.hpform.navlist[index].checked = false;
      } else {
        that.hpform.navlist[index].checked = true;
      }
    },
    editHpItem(item, index) {
      this.hpform.curindex = index;
      this.hpform.edititem.caption = item.sname;
      this.hpform.edititem.itype = item.itype;
      this.hpform.edititem.url = item.surl;
      this.hpform.edititem.dappid = item.dappid;
      this.hpform.edititem.appid = item.appid;
    },
    delHpItem(index) {
      this.hpform.navlist.splice(index, 1);
      this.checkSelectItem();
    },
    commitEditHpItem(index) {
      this.hpform.curindex = -1;
      this.hpform.navlist[index].sname = this.hpform.edititem.caption;
      this.hpform.navlist[index].itype = this.hpform.edititem.itype;
      this.hpform.navlist[index].surl = this.hpform.edititem.url;
      this.hpform.navlist[index].dappid = this.hpform.edititem.dappid;
      this.hpform.navlist[index].appid = this.hpform.edititem.appid;
    },
    checkSelectItem() {
      this.sellist = [];
      for (var i = 0; i < this.hpform.dapplist.length; i++) {
        this.hpform.dapplist[i].checked = false;
        for (var j = 0; j < this.hpform.navlist.length; j++) {
          console.log(this.hpform.dapplist[i]);
          console.log(this.hpform.navlist[j]);
          console.log(
            this.hpform.dapplist[i].indexname +
              " - " +
              this.hpform.navlist[j].sname
          );
          if (
            this.hpform.dapplist[i].indexname == this.hpform.navlist[j].sname
          ) {
            this.hpform.dapplist[i].checked = true;
            this.sellist.push(this.hpform.dapplist[i].indexname);
            break;
          }
        }
      }
      console.log("%%%%%%%%%%%%%%%%%%%%%%%");
      console.log(this.sellist);
    },
    selectHpItem(item) {
      var newItem = {};
      newItem.sname = item.indexname;
      newItem.itype = item.indextype;
      newItem.surl = item.indexid;
      newItem.dappid = item.dappid;
      newItem.appid = item.appid;
      newItem.checked = true;
      this.hpform.navlist.push(newItem);
      this.checkSelectItem();
    },
    addNewHpItem() {
      this.hpform.showNewView = false;
      var newItem = {};
      newItem.sname = this.hpform.newitem.caption;
      newItem.itype = this.hpform.newitem.itype;
      newItem.surl = this.hpform.newitem.url;
      newItem.dappid = this.hpform.newitem.dappid;
      newItem.appid = this.hpform.newitem.appid;
      this.hpform.navlist.push(newItem);
      this.checkSelectItem();
      this.hpform.newitem.caption = "";
      this.hpform.newitem.itype = "0";
      this.hpform.newitem.url = "";
      this.hpform.newitem.dappid = "";
      this.hpform.newitem.appid = "";
    }
  }
};
</script>
<style lang="scss" scoped>
#group {
  width: 100%;
  height: 100%;
  > div {
    width: 100%;
    min-height: 100%;
    padding: 20px;
  }
  .user {
    padding: 0;
    background: #f7f7f7;
    .adduserTop {
      border-bottom: 1px solid #ededed;
      padding: 20px 0 30px;
      background: #fff;
      text-align: center;
      ul {
        display: inline-block;
        li {
          font-size: 16px;
          color: #666666;
          margin-right: 60px;
          cursor: pointer;
        }
        li:last-child {
          margin-right: 0;
        }
        .active {
          color: #2e9cf1;
        }
      }
      .addusersearch {
        margin-top: 20px;
        input {
          height: 36px;
          width: 50%;
          border: 1px solid rgba(220, 220, 220, 1);
          margin-right: 30px;
          border-radius: 18px;
          padding: 0 15px;
        }
        button {
          width: 70px;
          height: 30px;
          background: rgba(46, 156, 241, 1);
          border-radius: 3px;
          color: #fff;
          border: 0;
          cursor: pointer;
        }
      }
    }
    .adduserBottom {
      padding: 0 20px;
      > div {
        color: #000;
        font-size: 14px;
        margin: 10px 0;
      }
      ul {
        li {
          width: 100%;
          // padding-right: 20px;
          float: left;
          position: relative;
          // margin-bottom: 20px;
          background: #fff;
          padding: 10px;
          display: flex;
          > div:first-child {
            width: 70px;
          }
          > div:last-child {
            flex: 1;
          }
          .icon {
            position: absolute;
            top: 0;
            right: 0;
          }
          .iconfont {
            display: none;
          }
          #rightList {
            position: absolute;
            background: #fff;
            right: 0;
            z-index: 999;
            width: 140px;
            border-radius: 4px;
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
            padding: 6px 0;
            top: 30px;
            img {
              width: 14px;
              height: 15px;
              margin-top: 7px;
              margin-right: 10px;
            }
            li {
              height: 30px;
              line-height: 30px;
              padding: 0 13px;
              border-bottom: 0;
            }
            :hover {
              background: #edebea;
            }
          }
          .avatar {
            height: 60px;
            width: 60px;
            border-radius: 50%;
            text-align: center;
            line-height: 60px;
            color: #fff;
            font-size: 16px;
            margin-right: 10px;
          }
          .info {
            height: 70px;
            .sumname {
              font-size: 14px;
              color: #000;
              margin-bottom: 4px;
              max-width: 80px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .job {
              color: #999999;
              font-size: 12px;
              margin-left: 10px;
              max-width: 100px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .sphone,
            .company {
              font-size: 12px;
              color: #000;
              margin-bottom: 5px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              /*! autoprefixer: off */
              -webkit-box-orient: vertical;
              /* autoprefixer: on */
              -webkit-line-clamp: 2;
            }
          }
          .buttongroup {
            button {
              width: 70px;
              height: 20px;
              background: #fff;
              border-radius: 3px;
              font-size: 12px;
              color: #2e9cf1;
              text-align: left;
              line-height: 18px;
              border: 0;
              // margin-right: 20px;
              cursor: pointer;
            }
            button:last-child {
              margin-right: 0;
            }
          }
        }
        li:hover {
          .iconfont {
            display: inline-block;
          }
        }
      }
    }
  }
  .groupleft,
  .groupright {
    width: 50%;
    height: 100%;
    padding: 10px 20px;
    .rightBox {
      height: 50%;
      padding: 10px 0;
    }
    .rightBox:last-child {
      border-top: 1px solid #dcdcdc;
    }
  }
  .groupleft {
    border-right: 1px solid #dcdcdc;
  }
}
.validation .desname {
  margin-top: 20px;
}
.sendMsg {
  div {
    margin-bottom: 10px;
    color: #666666;
  }
}
.chooselist {
  li {
    margin: 0 10px 10px 0;
    position: relative;
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
    }
    .selectcolor {
      position: absolute;
      width: 16px;
      height: 16px;
      bottom: 0;
      right: 0;
    }
  }
  li:first-child {
    border-radius: 0;
  }
}
.logopath {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
}
.listtitle {
  justify-content: space-between;
  .refresh {
    color: #999999;
    font-size: 12px;
    display: inline-block;
    margin-left: 20px;
    cursor: pointer;
  }
}
.adduser {
  font-size: 16px;
  color: rgba(153, 153, 153, 1);
  width: 80px;
  height: 32px;
  border: 1px solid rgba(204, 204, 204, 1);
  border-radius: 4px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  display: inline-block;
}
.center {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.searchuserlists {
  min-height: calc(54vh - 120px);
}
</style>
  <style>
.addlist .el-dialog__body {
  padding: 0;
}
.validation .el-dialog__body {
  height: auto;
}
.addlist .avatar-uploader.upimg {
  width: 40px;
  height: 40px;
}
.addlist .upimg .el-upload-dragger {
  height: 38px;
  width: 38px;
}
.addlist .upimg .el-upload-dragger img {
  height: 40px;
}
.addlist .avatar-uploader-icon {
  width: 36px;
  height: 36px;
  line-height: 36px !important;
}
.dapp .el-input,
.newauthor .el-input,
.newappname .el-input {
  width: 100%;
  margin-right: 20px;
}
.adduserBottom .el-row .el-col {
  padding: 10px !important;
}
</style>
  <style scoped lang="scss" rel="stylesheet/scss">
.newview {
  border: 1px solid #ddf;
  margin: 10px;
  padding: 10px;
}
.newsubmitdiv {
  width: 120px;
  margin: 10px auto;
}
.hptitlelab {
  word-break: keep-all;
  width: 80px;
}
#province,
#city,
#district {
  padding: 0.5rem 0.75rem;
  height: 40px;
  font-size: 1rem;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  float: left;
  margin-right: 10px;
}
.newappname .el-input,
.newauthor .el-input {
  width: 50%;
  margin-right: 20px;
}
</style>


// WEBPACK FOOTER //
// src/packages/addlist/um-addlist.vue